<script>
export default {
  data() {
    return {};
  },
};
</script>

<template>
  <div class="icon-arrow-wrapper">
    <div class="col left-arrow" @click="$emit('move-down')">
      <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-arrow'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.608 8.481l5.196 4.935L12 8.481" stroke="#030C16" stroke-width="2"/><path d="M6.871 11.584v-10" stroke="#030C16" stroke-width="2" stroke-linecap="square"/></svg>
    </div>
    <div class="col right-arrow" @click="$emit('move-up')">
      <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-arrow'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.178 6.519l5.196-4.935 5.196 4.935" stroke="#030C16" stroke-width="2"/><path d="M6.44 3.416v10" stroke="#030C16" stroke-width="2" stroke-linecap="square"/></svg>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.icon-arrow-wrapper {
  display: flex;

  .right-arrow {
    align-items: center;
    background: rgba($color-black-one-wo-rgb, 0.1);
    border-radius: 4px;
    display: flex;
    height: 4rem;
    justify-content: center;
    margin-left: 2px;

    path {
      stroke: $color-action;
    }

    &:hover {
      background: rgba($color-black-one-wo-rgb, 0.2);
      cursor: pointer;
    }
  }

  .left-arrow {
    align-items: center;
    background: rgba($color-black-one-wo-rgb, 0.05);
    border-radius: 4px;
    display: flex;
    height: 4rem;
    justify-content: center;
    margin-right: 2px;

    path {
      stroke: $color-action;
    }

    &:hover {
      background: rgba($color-black-one-wo-rgb, 0.15);
      cursor: pointer;
    }
  }
}
</style>
